// Mock data for the Library Website demo — no imports, no API calls.
// Supplies every field that any landing theme accesses (including optional ones).

export const MOCK_WEBSITE_LIBRARY = {
  id: 'demo-lib-001',
  name: 'Sunrise Study Hub',
  slug: 'sunrise-study-hub',
  address: '42, MG Road, Bangalore, Karnataka 560001',
  city: 'Bangalore',
  state: 'Karnataka',
  pincode: '560001',
  description:
    'Sunrise Study Hub is Bangalore\'s premier study destination — spacious, air-conditioned, and open 7 days a week. With ergonomic seating, high-speed Wi-Fi, and a zero-noise policy, we help you stay focused and achieve your goals. Join thousands of students who trust us for their daily study needs.',
  gallery: [
    'https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=800&q=80',
    'https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=800&q=80',
    'https://images.unsplash.com/photo-1568667256549-094345857637?w=800&q=80',
    'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=800&q=80',
    'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80',
    'https://images.unsplash.com/photo-1532012197267-da84d127e765?w=800&q=80',
  ],
  amenities: ['Wi-Fi', 'AC', 'CCTV', 'Lockers', 'Cafeteria', 'Printing'],
  open_time: '06:00',
  close_time: '23:00',
  operational_days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
  capacity: 80,
  available_seats: 34,
  locker_count: 40,
  contact_phone: '+91 98765 43210',
  contact_email: 'hello@sunrisestudyhub.in',
  rating: 4.7,
  total_reviews: 312,
  lat: 12.9716,
  lng: 77.5946,
  website_settings: null,
  theme: 'modern',
  accent_color: '#F26522',
};

export const MOCK_WEBSITE_PLANS = [
  {
    id: 'p1',
    name: 'Daily Pass',
    plan_type: 'daily',
    price_cents: 80,
    duration_days: 1,
    hours_per_day: 12,
    first_time_discount: 0,
    recurring: false,
    description: 'Perfect for a one-day focused session.',
  },
  {
    id: 'p2',
    name: 'Weekly Plan',
    plan_type: 'weekly',
    price_cents: 450,
    duration_days: 7,
    hours_per_day: 12,
    first_time_discount: 10,
    recurring: false,
    description: 'Great for short exam preparation.',
  },
  {
    id: 'p3',
    name: 'Monthly Plan',
    plan_type: 'monthly',
    price_cents: 1400,
    duration_days: 30,
    hours_per_day: 12,
    first_time_discount: 15,
    recurring: true,
    description: 'Our most popular plan — save more with monthly access.',
  },
  {
    id: 'p4',
    name: 'Half-Yearly Plan',
    plan_type: 'half_yearly',
    price_cents: 7200,
    duration_days: 180,
    hours_per_day: 12,
    first_time_discount: 20,
    recurring: false,
    description: 'Best value for serious exam aspirants.',
  },
];
